var map = {
	"./Vector.svg": 971,
	"./android.svg": 972,
	"./difficulty-english.svg": 973,
	"./down-swirly.svg": 447,
	"./graphic.svg": 974,
	"./komal.svg": 975,
	"./language.svg": 976,
	"./learn-python.svg": 977,
	"./linkedin.svg": 978,
	"./misc.svg": 979,
	"./never-typed.svg": 980,
	"./playstore.svg": 583,
	"./python.svg": 981,
	"./residential.svg": 982,
	"./twitter.svg": 983,
	"./typing.svg": 984,
	"./web-development.svg": 985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 582;